import React, { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import "../sass/styles.scss";

function Layout({ pageClass, children, headerClass }) {
  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Mac') !== -1) {
      document.body.classList.add('ua-safari');
    }
  }, []);
  return (
    <div className={` site-wrapper hcp-layout ${pageClass || ""}`}>
      <Header
      headerClass={headerClass}
      />
      <main className="site-content">{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
